<p class="section-title header">{{locale['LABEL_WIDGETS']}}</p>
<div class="widget-map-container list-fields">
    <div class="col-xs-3 widgets-list full-height">
            <ul class="list-items">
                <li class="list-item" *ngFor="let widget of templateWidgets" attr.name="wm-live-list-widget-{{widget?.name}}" (click)="onTemplateWidgetSelect(widget)" [ngClass]="{'active': selectedWidget === widget}">
                    <div class="item">
                        <span class="title">{{widget.name + (widget.aspectRatio || '')}}</span>
                        <span class="validation-icon done pull-right" *ngIf="widget.hasBinding"></span>
                    </div>
                </li>
            </ul>
        </div>
    <div class="col-xs-9 prop-list full-height">
        <div class="col-xs-7 full-height">
            <div>
                <div class="section-title">{{selectedWidget?.name + ' ' + locale['LABEL_WIDGET']}}</div>
            </div>
            <div class="form-group app-composite-widget clearfix" *ngFor="let prop of selectedWidget.widgetProps">
                <label class="col-xs-3 app-label">{{locale['LABEL_PROPERTY_' + prop.name.toUpperCase()]}}</label>
                <select class="app-select form-control" name="wm-live-list-prop-{{prop.name}}" [(ngModel)]="prop.field" (change)="updateWidgetProps(prop)">
                    <option *ngFor="let item of fields">{{item.field}}</option>
                </select>
                <i class="wm-icon wms wms-help" [tooltipAppendToBody]="true" tooltip="{{locale['MESSAGE_HELP_PROPERTY_' + prop?.name?.toUpperCase()]}}" placement="right"></i>
            </div>
        </div>
        <div class="col-xs-5 widget-screenshot text-center full-height">
            <span class="helper"></span><img [src]="('assets/images/widget-template/' + listImage | versionManager)"/>
        </div>
    </div>
</div>
